<template>
  <div id="app">
    <transition name="slide-right" mode="out-in">
      <router-view v-if="isRouterAlive"></router-view>
    </transition>
  </div>
</template>

<script>
  import 'babel-polyfill'

  export default {
    name: 'app',
    provide() {
      return {reload: this.reload}
    },
    data() {
      return {
        isRouterAlive: true
      }
    },
    components: {},
    methods: {
      reload() {
        this.isRouterAlive = false
        this.$nextTick(function () {
          this.isRouterAlive = true
        })
      }
    }
  }
</script>




// WEBPACK FOOTER //
// App.vue?28494bc0